import React from 'react';
import { Link } from 'react-router-dom';
import { FiPlus, FiChevronRight } from 'react-icons/fi';
import { useUserStore } from '../../stores/userStore';
import { useWebLocale } from '../../contexts/WebLocaleContext';
import { useColorScheme } from '../../contexts/ColorSchemeContext';
import { musicEditionCreateLabel } from './generated/branding';
import { editionStyle } from './MusicEditionPage';
export default function MusicEditionEntry({ profile }) {
  const user = useUserStore((s) => s.user),
    { locale } = useWebLocale(),
    { resolvedMode } = useColorScheme();
  if (!user?.id || String(user.id) !== String(profile.id) || user.nickname !== profile.nickname)
    return null;
  return (
    <Link
      to="/mypage/archive"
      state={{ editionFromMy: true }}
      className="pp-edition-entry"
      style={editionStyle(resolvedMode)}
    >
      <span className="pp-edition-entry-icon">
        <FiPlus size={22} />
      </span>
      <span>
        <strong>{musicEditionCreateLabel[locale]}</strong>
        <small>
          {locale === 'en'
            ? 'Turn your music taste into cards to share.'
            : '쌓아온 음악 취향을 카드로 만들고 공유해보세요.'}
        </small>
      </span>
      <FiChevronRight size={20} />
    </Link>
  );
}
